import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

// All exports use Europe/Lisbon, DD/MM/YYYY and 24-hour time.
const TZ = "Europe/Lisbon";
export const pdfDate = (iso) => (iso ? new Date(iso).toLocaleDateString("pt-PT", { timeZone: TZ, day: "2-digit", month: "2-digit", year: "numeric" }) : "");
export const pdfTime = (iso) => (iso ? new Date(iso).toLocaleTimeString("pt-PT", { timeZone: TZ, hour: "2-digit", minute: "2-digit", hour12: false }) : "");
const BRAND = [155, 27, 48];

function doc(title, subtitle) {
  const d = new jsPDF({ unit: "pt", format: "a4" });
  d.setFont("helvetica", "bold"); d.setFontSize(9); d.setTextColor(...BRAND);
  d.text("URBAN LISBON CHOIR", 40, 40);
  d.setTextColor(20); d.setFontSize(18); d.text(title, 40, 64);
  d.setFont("helvetica", "normal"); d.setFontSize(10); d.setTextColor(90);
  if (subtitle) d.text(subtitle, 40, 82);
  d.text(`Exportado em ${pdfDate(new Date().toISOString())} às ${pdfTime(new Date().toISOString())}`, 40, subtitle ? 96 : 82);
  return d;
}

const table = (d, head, body, startY) =>
  autoTable(d, { head: [head], body, startY, styles: { fontSize: 9, cellPadding: 5 }, headStyles: { fillColor: BRAND }, margin: { left: 40, right: 40 } });

// Footer on every page: brand + page numbering.
function save(d, file) {
  const n = d.getNumberOfPages();
  for (let i = 1; i <= n; i++) {
    d.setPage(i); d.setFont("helvetica", "normal"); d.setFontSize(8); d.setTextColor(130);
    d.text(`Urban Lisbon Choir · Documento pessoal · Página ${i} de ${n}`, 40, d.internal.pageSize.getHeight() - 24);
  }
  d.save(file);
}

const slug = (s) => (s || "documento").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export function exportCalendarPdf(events, periodLabel, typeLabel) {
  const d = doc("Calendário", periodLabel);
  table(d, ["Data", "Hora", "Tipo", "Evento", "Local", "Músicas"],
    events.map((e) => [pdfDate(e.starts_at), pdfTime(e.starts_at), typeLabel(e.type), e.title || "", [e.location, e.address].filter(Boolean).join(" · "), String(e.songs?.length || e.song_ids?.length || 0)]), 112);
  save(d, `calendario-${slug(periodLabel)}.pdf`);
}

export function exportSetlistPdf(event, typeLabel) {
  const sub = [typeLabel(event.type), pdfDate(event.starts_at), pdfTime(event.starts_at), event.location].filter(Boolean).join(" · ");
  const d = doc(event.title || "Alinhamento", sub);
  table(d, ["#", "Música", "Artista"], (event.songs || []).map((s, i) => [String(i + 1), s.title || "", s.artist || ""]), 112);
  save(d, `alinhamento-${slug(event.title)}${event.starts_at ? `-${pdfDate(event.starts_at).replace(/\//g, "-")}` : ""}.pdf`);
}

export function exportAttendancePdf(name, summary, rows) {
  const d = doc("Assiduidade individual", name);
  table(d, ["Presença", "Presenças", "Ausências", "Total"], [[`${summary.rate}%`, String(summary.present), String(summary.absent), String(summary.total)]], 112);
  if (rows.length) table(d, ["Data", "Hora", "Evento", "Estado"], rows.map((r) => [pdfDate(r.starts_at), pdfTime(r.starts_at), r.title, r.status]), d.lastAutoTable.finalY + 18);
  save(d, `assiduidade-${slug(name)}.pdf`);
}

export function exportChoirAttendancePdf(members) {
  const d = doc("Assiduidade do coro", "Classificações validadas mais recentes");
  table(d, ["Membro", "Naipe", "Presenças", "Ausências", "Por responder", "Taxa"],
    members.map((m) => [m.name || "", m.voice || "", String(m.present ?? 0), String(m.absent ?? 0), String(m.pending ?? 0), m.rate != null ? `${m.rate}%` : ""]), 112);
  save(d, "assiduidade-coro.pdf");
}

/** Poll summary: totals per option, who chose what and who has not answered. */
export function exportPollPdf(a, d) {
  const who = (m) => `${m.name}${m.voice ? ` (${m.voice})` : ""}`;
  const doc_ = doc(`Sondagem · ${a.title}`, `${a.poll.question || ""}${a.poll.question ? " · " : ""}${d.voted}/${d.total} responderam`);
  const rows = a.poll.options.map((o, i) => {
    const v = d.members.filter((m) => m.vote?.includes(i));
    return [o, String(v.length), `${d.voted ? Math.round((v.length / d.voted) * 100) : 0}%`, v.map(who).join(", ")];
  });
  const none = d.members.filter((m) => m.vote === null);
  if (none.length) rows.push(["Sem resposta", String(none.length), "", none.map(who).join(", ")]);
  table(doc_, ["Opção", "Votos", "%", "Quem"], rows, 112);
  save(doc_, `sondagem-${slug(a.title)}.pdf`);
}
